(async () => {

  if (!customElements.get('product-card-swiper')) {

    const { default: Swiper, Navigation, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Autoplay
    ]);

    class ProductCardSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-product-card]');

        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          threshold: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerView: 1,
          spaceBetween: 16,
          direction: 'horizontal'
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperElement.update();
            if(this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
          });

        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }
    window.ProductCardSlider = ProductCardSlider;
    customElements.define('product-card-swiper', ProductCardSlider);

  }

})();


if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      var colorSwatchWrapper = this.querySelector('grouped-product-swatches');

      if (colorSwatchWrapper) {
        var colorSwatches = colorSwatchWrapper.querySelectorAll('[data-item-image]');
        var imagesSlider = this.querySelector('product-card-swiper');

        colorSwatches.forEach((colorSwatch) => {

          colorSwatch.addEventListener('mouseover', () => {
            // Get image info from hovered color swatch
            let newImage = colorSwatch.dataset.itemImage;
            let newImageTitle = colorSwatch.dataset.product;

            // If images swiper
            if (imagesSlider) {
              // Find current visible/active slide
              let activeSlide = imagesSlider.querySelector('.swiper-slide-active');
              // Image
              let ImageWrapper = activeSlide.querySelector('[data-product-card-featured-image]');
              let ImageSources = ImageWrapper.querySelectorAll('source');
              let itemImage = ImageWrapper.querySelector('img');
              let currentImage = itemImage.src;
              let currentImageAlt = itemImage.alt;

              //Switch image on hover
              this.switchImage(newImage, newImageTitle, ImageSources, itemImage);

              //Switch back on mouse out
              colorSwatch.addEventListener('mouseout', () => {
                this.switchBack(itemImage, currentImage, currentImageAlt);
              });

            } else {
              //Image
              let ImageWrapper = this.querySelector('[data-product-card-featured-image]');
              let ImageSources = ImageWrapper.querySelectorAll('source');
              let itemImage = ImageWrapper.querySelector('img');
              let currentImage = itemImage.src;
              let currentImageAlt = itemImage.alt;

              //Switch image on hover
              this.switchImage(newImage, newImageTitle, ImageSources, itemImage);

              //Switch back on mouse out
              colorSwatch.addEventListener('mouseout', () => {
                this.switchBack(itemImage, currentImage, currentImageAlt);
              });

            }
          });
        });
      }
    }
    /**
    * Switch image
    * @param Object event
    * @description Change the image
    */
    switchImage(newImage, newImageTitle, ImageSources, itemImage) {
      //Switch image
      itemImage.src = newImage;
      itemImage.removeAttribute('srcset');
      itemImage.alt = newImageTitle;
      ImageSources.forEach((source) => {
        source.remove();
      });
    }

    /**
    * Switch back
    * @param Object event
    * @description Change the image on mouse leave
    */
    switchBack(itemImage, currentImage, currentImageAlt) {
      //Switch image back
      itemImage.src = currentImage;
      itemImage.alt = currentImageAlt;
    }
  }

  window.ProductCard = ProductCard;
  customElements.define('product-card', ProductCard);
}